<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Connection Api" class="d-icon d-icon--connection-api" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.709 10.416a.5.5 0 0 1 0-.707L5.23 8.188 4.062 7.02l-1.52 1.52a.5.5 0 1 1-.707-.707l1.521-1.521-.584-.584a.5.5 0 0 1 0-.708l1.562-1.56a2.268 2.268 0 0 1 3.207 0l.271.271 1.21-1.209a.5.5 0 1 1 .707.708l-1.21 1.209.272.271a2.268 2.268 0 0 1 0 3.207L7.229 9.48a.5.5 0 0 1-.708 0l-.583-.584-1.522 1.521a.5.5 0 0 1-.707 0Zm3.125-6.25a1.268 1.268 0 0 0-1.793 0L3.832 5.375l3.043 3.043 1.209-1.209a1.268 1.268 0 0 0 0-1.793l-1.25-1.25Z" fill="currentColor"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconConnectionApi',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
